import ProblemSection from './ProblemSection';
export default ProblemSection;
